

document.addEventListener('DOMContentLoaded', function () {
    const form              = document.getElementById('suscription_form');
    const socialIdInput     = document.getElementById('social_id');
    const firstNameInput    = document.getElementById('first_name');
    const lastNameInput     = document.getElementById('last_name');
    const emailInput        = document.getElementById('email');
    const phoneInput        = document.getElementById('phone');
    const terms             = document.getElementById('agree');

    const viewChargesInfoLink = $('#kt_login_signup');
    const returnToSubscriptionButton = $('#kt_login_signup_cancel');

    function toggleChargesForm(showChargesForm) {
        // Obtener todos los elementos con la clase 'login-signup'
        const signupElements = document.querySelectorAll('.login-signup');

        // Cambiar el valor de display según la condición
        if (showChargesForm) {
            // Ocultar el formulario de suscripción
            const signinElements = document.querySelectorAll('.login-signin');
            signinElements.forEach(element => {
                element.style.display = 'none';  // Cambia a 'none' o el valor que necesites
            });

            // Mostrar el formulario de cargos
            signupElements.forEach(element => {
                element.style.display = 'block';  // Cambia a 'block' o el valor que necesites
            });


        } else {
            // Mostrar el formulario de suscripción
            signupElements.forEach(element => {
                element.style.display = 'none';  // Cambia a 'none' o el valor que necesites
            });

            // Ocultar el formulario de cargos
            const signinElements = document.querySelectorAll('.login-signin');
            signinElements.forEach(element => {
                element.style.display = 'block';  // Cambia a 'block' o el valor que necesites
            });
        }
    }

    // Event listener para el enlace de ver información de cargos
    if (viewChargesInfoLink.length) {
        viewChargesInfoLink.on('click', function () {
            toggleChargesForm(true); // Muestra el formulario de cargos
        });
    }

    // Event listener para el botón de regresar a la suscripción
    if (returnToSubscriptionButton.length) {
        returnToSubscriptionButton.on('click', function (event) {
            event.preventDefault(); // Evitar recarga de la página
            toggleChargesForm(false); // Muestra el formulario de suscripción
        });
    }

    // Iniciar mostrando el formulario de suscripción y ocultando el de cargos
    toggleChargesForm(false); // `false` para que el formulario de suscripción esté visible al cargar

    // Función para mostrar error debajo del input
    function showError(input, message) {
        let error = input.parentElement.querySelector('.error-message');
        if (!error) {
            error = document.createElement('div');
            error.className = 'error-message';
            error.style.color = 'red';
            input.parentElement.appendChild(error);
        }
        error.textContent = message;
    }

    // Función para limpiar los mensajes de error
    function clearError(input) {
        const error             = input.parentElement.querySelector('.error-message');
        if (error) {
            error.textContent   = '';
        }
    }

    // Función de validación del RUT
    function validateRUT(rut) {
        var regex = /^[0-9]+-[0-9kK]{1}$/;
        if (!regex.test(rut)) return false;

        var tmp = rut.split('-');
        var digv = tmp[1].toLowerCase();
        var cuerpo = tmp[0];
        var suma = 0;
        var multiplo = 2;

        for (var i = cuerpo.length - 1; i >= 0; i--) {
            suma += multiplo * cuerpo.charAt(i);
            multiplo = multiplo < 7 ? multiplo + 1 : 2;
        }

        var dvEsperado = 11 - (suma % 11);
        dvEsperado = dvEsperado == 11 ? 0 : dvEsperado == 10 ? 'k' : dvEsperado;
        return dvEsperado == digv;
    }

    // Validación de campos vacíos
    function isNotEmpty(input, message) {
        if (input.value.trim() === '') {
            showError(input, message);
            return false;
        }
        clearError(input);
        return true;
    }

    // Validación del correo electrónico
    function validateEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    // Validación del teléfono
    function validatePhone(phone) {
        // Expresión regular ajustada para hacer opcional el '+'
        const phoneRegex = /^\+?56\d{9}$/;
        return phoneRegex.test(phone);
    }

    // Evento de envío del formulario
    form.addEventListener('submit', function (event) {
        event.preventDefault();
        let isValid = true;

        // Validar RUT
        if (!isNotEmpty(socialIdInput, 'RUT es requerido.') || !validateRUT(socialIdInput.value)) {
            showError(socialIdInput, 'RUT no valido. Ingrese sin puntos y con guión');
            isValid = false;
        } else {
            clearError(socialIdInput);
        }

        // Validar nombre
        if (!isNotEmpty(firstNameInput, 'Nombre es requerido.')) {
            isValid = false;
        } else {
            clearError(firstNameInput);
        }

        // Validar apellidos
        if (!isNotEmpty(lastNameInput, 'Apellido es requerido.')) {
            isValid = false;
        } else {
            clearError(lastNameInput);
        }

        // Validar email
        if (!isNotEmpty(emailInput, 'E-mail es requerido.') || !validateEmail(emailInput.value)) {
            showError(emailInput, 'Formato incorrecto de correo');
            isValid = false;
        } else {
            clearError(emailInput);
        }

        // Validar teléfono
        if (!phoneInput.hasAttribute('readonly')) {
            if (!isNotEmpty(phoneInput, 'Teléfono móvil es requerido.') || !validatePhone(phoneInput.value)) {
                showError(phoneInput, 'Ingrese 11 digitos comenzando con 569');
                isValid = false;
            } else {
                clearError(phoneInput);
            }
        }

         // Validar términos y condiciones
         if (!terms.checked) {
            showError(terms, "Debes aceptar las condiciones del PAT.");
            isValid = false;
        } else {
            clearError(terms);
        }

        // Si todo es válido, enviar el formulario
        if (isValid) {
            form.submit();
        }else {
            Swal.fire({
                text: "¡Lo sentimos! Por favor revisa los datos ingresados e intenta nuevamente.",
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Entendido, lo revisaré",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-light-primary"
                }
            });
        }
    });
});
